import { useNavigate } from "@tanstack/react-location"
import { Dialog, IconButton } from "materia"
import { type PropsWithChildren } from "react"
import s from "./NewsPostViewWrapper.module.scss"

// Wraps the news post in components shared between all states (loading,
// error and success) so we can reuse the same dialog and close button.
export const NewsPostViewWrapper = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate()
  const closeRoute = "/news"

  const onClose = () => {
    navigate({ to: closeRoute })
  }

  // TODO: would be nice to unify Modal/Dialog components
  // and not have a separate reimplementation for fullscreen here
  return (
    <Dialog ariaLabel="News post" onClose={onClose}>
      <div className={s.view}>
        {children}
        <IconButton
          as="button"
          className={s.closeButton}
          icon="Close"
          onClick={onClose}
          aria-label="Close"
        />
      </div>
    </Dialog>
  )
}
